export default {"src":"/_next/static/media/enhanced-security.04e81536.svg","height":394,"width":394,"blurWidth":0,"blurHeight":0};